// Centralized image export. All static assets live in /public/avatars
// and are served as-is without build processing. Each image key below
// maps to either a LinkedIn CDN URL (primary) or a local path + SVG
// fallback. We deliberately do not hot-link Unsplash photos anymore
// -- that broke reliability and looked generic.

// Local profile picture used as the primary hero avatar to optimize cache TTL
const localAvatar = '/avatars/Profile/mohit-arora.webp';
// GitHub profile picture used as a fallback (CDN)
const ghAvatar = 'https://avatars.githubusercontent.com/u/29508236?v=4&s=372';

// Recommender Avatar Local Paths & CDNs
// Each recommender has a primary LinkedIn CDN URL (for best resolution)
// and a local JPG fallback (served from /public) plus an SVG fallback
// for offline reliability. This CDN -> local -> SVG chain ensures
// avatars render even when LinkedIn rate-limits or the network is down.
const aakashLocal = '/avatars/Recommendations/aakash-sharma.jpg';
// const aakashLinkedIn = 'https://media.licdn.com/dms/image/v2/D4D03AQEWpbrX6tRsEg/profile-displayphoto-scale_400_400/B4DZj_tg3bGsAg-/0/1756636779221?e=1782345600&v=beta&t=by-9Ph8PllZAPC-rrCEEp5DLXr5ctkB9s4eHPmtXrqg';

// Akash Mewati -- Game Developer, colleague at MadOverGames
const akashMewatiLocal = '/avatars/Recommendations/akash-mewati.jpg';
// const akashMewatiLinkedIn = 'https://media.licdn.com/dms/image/v2/D4D35AQHBCE0EW1UBEA/profile-framedphoto-shrink_400_400/B4DZ6RqitKIMAU-/0/1780560309578?e=1781362800&v=beta&t=g5bYgJOCR69bpFrpOsIxiZe1q6U01mNVoYGBq6P0otk';

// Amit Raiyani -- Game Developer, colleague at MadOverGames
const amitLocal = '/avatars/Recommendations/amit-raiyani.jpg';
// const amitLinkedIn = 'https://media.licdn.com/dms/image/v2/D4D35AQEw2kr0mG7Zew/profile-framedphoto-shrink_400_400/B4DZjljvUAIEAk-/0/1756198008368?e=1781362800&v=beta&t=OYAXry4cXzSNkFojNw6cKYxJHUmk7LnF21wz53bRbkU';

// Bhavuk Jain -- Software Engineer, colleague at MadOverGames
const bhavukLocal = '/avatars/Recommendations/bhavuk-jain.jpg';
// const bhavukLinkedIn = 'https://media.licdn.com/dms/image/v2/D5603AQFCEhWNbnsXCQ/profile-displayphoto-scale_400_400/B56Z2sL52JHgAs-/0/1776710297640?e=1782345600&v=beta&t=Uyt9aevqcOLfoYQ_33JtZXizSH8NBLo-4M5yx5IHiBg';

// Chitraksh Luthra -- Concept Artist and Animator, creative collaborator at MadOverGames
const chitrakshLocal = '/avatars/Recommendations/chitraksh-luthra.jpg';
// const chitrakshLinkedIn = 'https://media.licdn.com/dms/image/v2/D5635AQGlDcGzlSyX8A/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1736239253377?e=1781362800&v=beta&t=rhAo-VZ1T4qQTYq52KY1xeJP-7Y0ToUldrWCERowqMQ';

// Pratik Shinde -- Senior Test Engineer, QA colleague at MadOverGames
const pratikLocal = '/avatars/Recommendations/pratik-shinde.jpg';
// const pratikLinkedIn = 'https://media.licdn.com/dms/image/v2/D5635AQGZjlbxtw6omA/profile-framedphoto-shrink_400_400/B56ZueRfltG0Ag-/0/1767886945036?e=1781362800&v=beta&t=kSZYWkOi48LTHVdDs0voE0mmXeUaPQB4USDm3jEvi-g';

// Rudransh Solanki -- Backend / Unity Developer, colleague at MadOverGames
const rudranshLocal = '/avatars/Recommendations/rudransh-solanki.jpg';
// const rudranshLinkedIn = 'https://media.licdn.com/dms/image/v2/D4D03AQH376se968zeg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1686379309520?e=1782345600&v=beta&t=-6id88YJI8uUxNtyIfnm17w5aBQrF2zwyVYMPW_86AI';

// Sagar Saini -- Senior Game / AR VR Developer, colleague at MadOverGames
const sagarLocal = '/avatars/Recommendations/sagar-saini.jpg';
// const sagarLinkedIn = 'https://media.licdn.com/dms/image/v2/D5635AQFxxHGy0vwWzw/profile-framedphoto-shrink_400_400/B56ZxTxPeFIIAg-/0/1770931943547?e=1781362800&v=beta&t=oVJDyU735chq1pJXdwHIe2xYFvZEvs_Ng4gvP4F45iA';

// Shashank Dwivedi -- Associate Product Manager, PM colleague at MadOverGames
const shashankLocal = '/avatars/Recommendations/shashank-dwivedi.jpg';
// const shashankLinkedIn = 'https://media.licdn.com/dms/image/v2/D5603AQFaAvMd32H9cA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1705816906179?e=1782345600&v=beta&t=GO0YRyGOObnvMhBKQsmxk5LGFdRi1K-M9SZxdXSH5y8';

// Shubham Mittal -- Engineering Manager, Mohit's senior / teammate at MadOverGames
const shubhamLocal = '/avatars/Recommendations/shubham-mittal.jpg';
// const shubhamLinkedIn = 'https://media.licdn.com/dms/image/v2/D5603AQG2LQHTbeYGAA/profile-displayphoto-scale_400_400/B56ZmbpcecJsAk-/0/1759252966748?e=1782345600&v=beta&t=vdKjyGfdARLhOuLLqPAXu4nSVmyC0OS99O4IHoMcYVQ';

// Suraj Kumar -- Game Developer who reported to Mohit at MadOverGames
const surajLocal = '/avatars/Recommendations/suraj-kumar.jpg';
// const surajLinkedIn = 'https://media.licdn.com/dms/image/v2/D5603AQEd1n_cq_hq1Q/profile-displayphoto-shrink_400_400/B56ZRMrgMUH0Ak-/0/1736453261040?e=1782345600&v=beta&t=-XooJlcRcZDDTx4nv3mVRXAuLf4ia-bEjoQEH3C_YtM';

export const images = {
  // Hero
  // Primary profile image (local JPG) and fallback chain (GitHub CDN -> SVG)
  profile: localAvatar,
  profileRobot: '/avatars/Profile/mohit-arora-robot.png',
  profileFallbacks: [ghAvatar], // '/avatars/Profile/mohit-arora.svg' (fallback relocated)
  ghAvatar,

  // Experience / Company logos
  extramarksLogo: '/avatars/Professional_Journey/company-extramarks.webp',
  madOverGamesLogo: '/avatars/Professional_Journey/company-madovergames.webp',
  thinkNextLogo: '/avatars/Professional_Journey/company-thinknext.webp',

  // Education / Institution logos
  thaparLogo: '/avatars/Education/edu-thapar-new.webp',
  davLogo: '/avatars/Education/edu-dav-new.webp',

  // Certificates (all converted to WebP for 80% size reduction)
  certAccioJobFlipkart: '/avatars/Certificates/cert-acciojob-flipkart.webp',
  certCppExcellence: '/avatars/Certificates/cert-cpp-excellence.webp',
  certCyberConflicts: '/avatars/Certificates/cert-cyber-conflicts.webp',
  certCybersecurity: '/avatars/Certificates/cert-cybersecurity.webp',
  certDbms: '/avatars/Certificates/cert-dbms.webp',
  certDsa: '/avatars/Certificates/cert-dsa.webp',
  certFlutterSession: '/avatars/Certificates/cert-flutter-session.webp',
  certFullstack: '/avatars/Certificates/cert-fullstack.webp',
  certJsAkshay: '/avatars/Certificates/cert-js-akshay.webp',
  certMog2Yrs: '/avatars/Certificates/cert-mog-2yrs.webp',
  certMog3Yrs: '/avatars/Certificates/cert-mog-3yrs.webp',
  certSystemDesign: '/avatars/Certificates/cert-system-design.webp',
  certThaparCv: '/avatars/Certificates/cert-thapar-cv.webp',
  certThaparVr: '/avatars/Certificates/cert-thapar-vr.webp',
  certUdemySql: '/avatars/Certificates/cert-udemy-sql.webp',
  certUnsaidTalks: '/avatars/Certificates/cert-unsaidtalks.webp',
  certVirsa: '/avatars/Certificates/cert-virsa.webp',
  certWriting: '/avatars/Certificates/cert-writing.webp',

  // Recommender avatars
  // Primary: local JPG (<10KB, instant). Fallback 1: SVG (~0.5KB). Fallback 2: LinkedIn CDN (only if both local files fail).
  avatarAakash: aakashLocal,
  // avatarAakashFallbacks: ['/avatars/Recommendations/fallback/aakash-sharma.svg', aakashLinkedIn],        // Aakash Sharma
  avatarAkashMewati: akashMewatiLocal,
  // avatarAkashMewatiFallbacks: ['/avatars/Recommendations/fallback/akash-mewati.svg', akashMewatiLinkedIn], // Akash Mewati
  avatarAmit: amitLocal,
  // avatarAmitFallbacks: ['/avatars/Recommendations/fallback/amit-raiyani.svg', amitLinkedIn],              // Amit Raiyani
  avatarBhavuk: bhavukLocal,
  // avatarBhavukFallbacks: ['/avatars/Recommendations/fallback/bhavuk-jain.svg', bhavukLinkedIn],           // Bhavuk Jain
  avatarChitraksh: chitrakshLocal,
  // avatarChitrakshFallbacks: ['/avatars/Recommendations/fallback/chitraksh-luthra.svg', chitrakshLinkedIn], // Chitraksh Luthra
  avatarPratik: pratikLocal,
  // avatarPratikFallbacks: ['/avatars/Recommendations/fallback/pratik-shinde.svg', pratikLinkedIn],         // Pratik Shinde
  avatarRudransh: rudranshLocal,
  // avatarRudranshFallbacks: ['/avatars/Recommendations/fallback/rudransh-solanki.svg', rudranshLinkedIn],  // Rudransh Solanki
  avatarSagar: sagarLocal,
  // avatarSagarFallbacks: ['/avatars/Recommendations/fallback/sagar-saini.svg', sagarLinkedIn],             // Sagar Saini
  avatarShashank: shashankLocal,
  // avatarShashankFallbacks: ['/avatars/Recommendations/fallback/shashank-dwivedi.svg', shashankLinkedIn],  // Shashank Dwivedi
  avatarShubham: shubhamLocal,
  // avatarShubhamFallbacks: ['/avatars/Recommendations/fallback/shubham-mittal.svg', shubhamLinkedIn],      // Shubham Mittal
  avatarSuraj: surajLocal,
  // avatarSurajFallbacks: ['/avatars/Recommendations/fallback/suraj-kumar.svg', surajLinkedIn],             // Suraj Kumar
} as const;
